"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
var BiLoggerFactory = require("wix-bi-logger-client/dist/bi-logger-factory");
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'hp' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = (webOrMobileLogger instanceof BiLoggerFactory) ? webOrMobileLogger : webOrMobileLogger.factory(config);
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams) {
                return _this.bi.log(logParams);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 19 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'hp' });
    }
    ;
    /**
    * @typedef {Object} clickOnShowUpdatesUpdatesAndReleasesPageParams
    * @property {string} button_name - last week, last month, etc
    **/
    /**
     * Name: Click on show updates  - Updates and Releases page. Evid: 336.
     * Event description: Click on the show updates button.
    
     * button_name - Type: string. Desc: last week, last month, etc
     * @param {clickOnShowUpdatesUpdatesAndReleasesPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnShowUpdatesUpdatesAndReleasesPage = function (params) {
        return this.bi.log(__assign({ evid: 336 }, params));
    };
    /**
    * @typedef {Object} clickOnSignInFromHeaderParams
    * @property {string} origin - origin
    **/
    /**
     * Name: Click on sign-in from header. Evid: 314.
     * Event description: Click on sign-in from header.
    
     * origin - Type: string. Desc: origin
     * @param {clickOnSignInFromHeaderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnSignInFromHeader = function (params) {
        return this.bi.log(__assign({ evid: 314 }, params));
    };
    /**
    * @typedef {Object} verticalSelectorFullStoryStartSessionParams
    * @property {Url} fullstoryurl - FullStory recording URL
    **/
    /**
     * Name: vertical selector - FullStory start session. Evid: 325.
     * Event description: vertical selector - FullStory started recording session.
    
     * fullstoryurl - Type: url. Desc: FullStory recording URL
     * @param {verticalSelectorFullStoryStartSessionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.verticalSelectorFullStoryStartSession = function (params) {
        return this.bi.log(__assign({ evid: 325 }, params));
    };
    /**
    * @typedef {Object} clickOnTopicUpdatesAndReleasesPageParams
    * @property {string} button_name - Button title
    **/
    /**
     * Name: Click on topic - Updates and Releases page. Evid: 334.
     * Event description: Click on any of the topics in the left side bar.
    
     * button_name - Type: string. Desc: Button title
     * @param {clickOnTopicUpdatesAndReleasesPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnTopicUpdatesAndReleasesPage = function (params) {
        return this.bi.log(__assign({ evid: 334 }, params));
    };
    /**
    * @typedef {Object} clickOnHeaderParams
    * @property {string} origin - page's url
    * @property {Url} url - http://www.wix.com/sample/website
    * @property {string} row - first, second
    * @property {string} sub_tab - sub tab (if there is)
    * @property {string} tab - tab name
    * @property {string} version - Homepage version
    **/
    /**
     * Name: Click on header. Evid: 311.
     * Event description: Click on header.
    
     * origin - Type: string. Desc: page's url
     *
     * url - Type: url. Desc: http://www.wix.com/sample/website
     *
     * row - Type: string. Desc: first, second
     *
     * sub_tab - Type: string. Desc: sub tab (if there is)
     *
     * tab - Type: string. Desc: tab name
     *
     * version - Type: string. Desc: Homepage version
     * @param {clickOnHeaderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnHeader = function (params) {
        return this.bi.log(__assign({ evid: 311 }, params));
    };
    /**
    * @typedef {Object} hpSecondaryCtaParams
    * @property {string} additional_info - additional info on CTA (json)
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {string} message - CTA text
    * @property {Url} origin - tab's url
    * @property {number} total - total folds - amount of fold in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP - secondary CTA. Evid: 327.
     * Event description: HP - secondary CTA - all clicks that are not 'start now' or 'sign in'.
    
     * additional_info - Type: string. Desc: additional info on CTA (json)
     *
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * message - Type: string. Desc: CTA text
     *
     * origin - Type: url. Desc: tab's url
     *
     * total - Type: numeric. Desc: total folds - amount of fold in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpSecondaryCtaParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpSecondaryCta = function (params) {
        return this.bi.log(__assign({ evid: 327 }, params));
    };
    /**
    * @typedef {Object} timeInFoldParams
    * @property {number} delta - time in millisec
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {Url} origin - tab's url
    * @property {number} total - total folds - amount of folds in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: Time in fold. Evid: 321.
     * Event description: Time between active fold to inactive fold.
    
     * delta - Type: numeric. Desc: time in millisec
     *
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * origin - Type: url. Desc: tab's url
     *
     * total - Type: numeric. Desc: total folds - amount of folds in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {timeInFoldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.timeInFold = function (params) {
        return this.bi.log(__assign({ evid: 321 }, params));
    };
    /**
    * @typedef {Object} verticalSelectorUserClosedPageParams
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {Url} origin - tab's url
    * @property {string} source - method of leaving the vertical selector
    * @property {number} total - total folds - amount of folds in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: Vertical selector - user closed page. Evid: 320.
     * Event description: user closed selector page.
    
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * origin - Type: url. Desc: tab's url
     *
     * source - Type: string. Desc: method of leaving the vertical selector
     *
     * total - Type: numeric. Desc: total folds - amount of folds in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {verticalSelectorUserClosedPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.verticalSelectorUserClosedPage = function (params) {
        return this.bi.log(__assign({ evid: 320 }, params));
    };
    /**
    * @typedef {Object} hpFinishLoadingPartialLoadHtmlFinishedJsStartRunningParams
    * @property {number} delta - time in millisec to load HP
    * @property {Url} origin - tab's url
    * @property {Url} origin_copy - tab's url
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP finish loading - partial load - Html Finished, JS Start running. Evid: 340.
     * Event description: HP finish loading - partial load - Html Finished, JS Start running.
    
     * delta - Type: numeric. Desc: time in millisec to load HP
     *
     * origin - Type: url. Desc: tab's url
     *
     * origin_copy - Type: url. Desc: tab's url
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpFinishLoadingPartialLoadHtmlFinishedJsStartRunningParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpFinishLoadingPartialLoadHtmlFinishedJsStartRunning = function (params) {
        return this.bi.log(__assign({ evid: 340 }, params));
    };
    /**
    * @typedef {Object} hpStartLoadingParams
    * @property {number} delta - null
    * @property {Url} origin - tab's url
    * @property {Url} origin_copy - null
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP start loading. Evid: 315.
     * Event description: Home page start loading.
    
     * delta - Type: numeric.
     *
     * origin - Type: url. Desc: tab's url
     *
     * origin_copy - Type: url.
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpStartLoadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpStartLoading = function (params) {
        return this.bi.log(__assign({ evid: 315 }, params));
    };
    /**
    * @typedef {Object} clickOnStartNowParams
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {string} message - CTA text
    * @property {Url} origin - tab's url
    * @property {number} total - total folds - amount of fold in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: Click on 'start now'. Evid: 300.
     * Event description: Click on 'start now' button.
    
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * message - Type: string. Desc: CTA text
     *
     * origin - Type: url. Desc: tab's url
     *
     * total - Type: numeric. Desc: total folds - amount of fold in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {clickOnStartNowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnStartNow = function (params) {
        return this.bi.log(__assign({ evid: 300 }, params));
    };
    /**
    * @typedef {Object} hpFinishLoadingPartialLoadJsOnDomReadyParams
    * @property {number} delta - time in millisec to load HP
    * @property {Url} origin - tab's url
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP finish loading - partial load - JS on DOM ready. Evid: 341.
     * Event description: HP finish loading - partial load - JS on DOM ready.
    
     * delta - Type: numeric. Desc: time in millisec to load HP
     *
     * origin - Type: url. Desc: tab's url
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpFinishLoadingPartialLoadJsOnDomReadyParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpFinishLoadingPartialLoadJsOnDomReady = function (params) {
        return this.bi.log(__assign({ evid: 341 }, params));
    };
    /**
    * @typedef {Object} hpStartLoadingPreJsParams
    * @property {number} delta - time in millisec to load HP
    * @property {Url} origin - tab's url
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP start loading - pre JS. Evid: 342.
     * Event description: This event fires when the homepage starts to load, before the JS.
    
     * delta - Type: numeric. Desc: time in millisec to load HP
     *
     * origin - Type: url. Desc: tab's url
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpStartLoadingPreJsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpStartLoadingPreJs = function (params) {
        return this.bi.log(__assign({ evid: 342 }, params));
    };
    /**
    * @typedef {Object} clickOnTemplateCategoryParams
    * @property {string} button_type - text/template click
    * @property {string} main_category - business, music, photography, creative arts, online store, restaurants
    * @property {Url} origin - tab's url
    * @property {number} position - 1,2,3,4,5,6
    **/
    /**
     * Name: click on template category. Evid: 304.
     * Event description: click on 'see all business/ music/ photography templates'.
    
     * button_type - Type: string. Desc: text/template click
     *
     * main_category - Type: string. Desc: business, music, photography, creative arts, online store, restaurants
     *
     * origin - Type: url. Desc: tab's url
     *
     * position - Type: numeric. Desc: 1,2,3,4,5,6
     * @param {clickOnTemplateCategoryParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnTemplateCategory = function (params) {
        return this.bi.log(__assign({ evid: 304 }, params));
    };
    /**
    * @typedef {Object} clickOnVideoParams
    * @property {Url} video_url - https://www.youtube.com/watch?v=1wBcAe3Badc, http://static.wix.com/services/html-landing/hp/brazil/videos/en/video.flv
    **/
    /**
     * Name: Click on video. Evid: 302.
     * Event description: clicking on any video on the homepage.
    
     * video_url - Type: url. Desc: https://www.youtube.com/watch?v=1wBcAe3Badc, http://static.wix.com/services/html-landing/hp/brazil/videos/en/video.flv
     * @param {clickOnVideoParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnVideo = function (params) {
        return this.bi.log(__assign({ evid: 302 }, params));
    };
    /**
    * @typedef {Object} clickOnScrollUpButtonParams
    
    **/
    /**
     * Name: click on scroll-up button. Evid: 310.
     * Event description: click on scroll-up button.
    
    
     * @param {clickOnScrollUpButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnScrollUpButton = function (params) {
        return this.bi.log(__assign({ evid: 310 }, params));
    };
    /**
    * @typedef {Object} clickOnFooterParams
    * @property {string} button_name - button name
    * @property {string} origin - tab's url
    * @property {Url} url - http://www.wix.com/sample/website
    * @property {string} type - left, main
    * @property {string} version - HP version
    **/
    /**
     * Name: Click on footer. Evid: 312.
     * Event description: Click on footer.
    
     * button_name - Type: string. Desc: button name
     *
     * origin - Type: string. Desc: tab's url
     *
     * url - Type: url. Desc: http://www.wix.com/sample/website
     *
     * type - Type: string. Desc: left, main
     *
     * version - Type: string. Desc: HP version
     * @param {clickOnFooterParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnFooter = function (params) {
        return this.bi.log(__assign({ evid: 312 }, params));
    };
    /**
    * @typedef {Object} hpHomeVideoLoadSuccessParams
    * @property {number} delta - time in millisec
    * @property {Url} origin - tab's url
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP - home video load success. Evid: 322.
     * Event description: Time between HP start loading (315) to home fold video starts playing.
    
     * delta - Type: numeric. Desc: time in millisec
     *
     * origin - Type: url. Desc: tab's url
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpHomeVideoLoadSuccessParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpHomeVideoLoadSuccess = function (params) {
        return this.bi.log(__assign({ evid: 322 }, params));
    };
    /**
    * @typedef {Object} exploreClickOnViewSiteParams
    * @property {string} name - name of site opened in the explore page
    * @property {string} url - url of site opened in the explore page
    **/
    /**
     * Name: Explore - click on "view site". Evid: 328.
     * Event description: Explore page - user clicked on "view site".
    
     * name - Type: string. Desc: name of site opened in the explore page
     *
     * url - Type: string. Desc: url of site opened in the explore page
     * @param {exploreClickOnViewSiteParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exploreClickOnViewSite = function (params) {
        return this.bi.log(__assign({ evid: 328 }, params));
    };
    /**
    * @typedef {Object} hpFinishLoadingParams
    * @property {number} delta - null
    * @property {Url} origin - tab's url
    * @property {Url} origin_copy - null
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP finish loading. Evid: 316.
     * Event description: Home page finish loading.
    
     * delta - Type: numeric.
     *
     * origin - Type: url. Desc: tab's url
     *
     * origin_copy - Type: url.
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpFinishLoadingParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpFinishLoading = function (params) {
        return this.bi.log(__assign({ evid: 316 }, params));
    };
    /**
    * @typedef {Object} searchButtonClickUpdatesAndReleasesPageParams
    * @property {string} search_term - Search term
    **/
    /**
     * Name: Search button click - Updates and Releases page. Evid: 333.
     * Event description: Click on the magnifying glass in the search bar.
    
     * search_term - Type: string. Desc: Search term
     * @param {searchButtonClickUpdatesAndReleasesPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchButtonClickUpdatesAndReleasesPage = function (params) {
        return this.bi.log(__assign({ evid: 333 }, params));
    };
    /**
    * @typedef {Object} clickOnCreateYoursNowButtonParams
    * @property {Url} url - http://www.wix.com/website/templates
    **/
    /**
     * Name: Click on 'create yours now' button. Evid: 308.
     * Event description: Click on 'create yours now' button.
    
     * url - Type: url. Desc: http://www.wix.com/website/templates
     * @param {clickOnCreateYoursNowButtonParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnCreateYoursNowButton = function (params) {
        return this.bi.log(__assign({ evid: 308 }, params));
    };
    /**
    * @typedef {Object} verticalSelectorFinishLoadParams
    * @property {number} delta - time in millisec
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {Url} origin - tab's url
    * @property {string} referral - referral url. When creating a new site from my account:  {MA_topbar, MA_site_list_top, MA_site_list_bottom,  MA_account_templates}
    * @property {string} source - vertical selector - reason for appearing
    * @property {number} total - total folds - amount of folds in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: Vertical Selector - finish load. Evid: 319.
     * Event description: vertical selector load complete.
    
     * delta - Type: numeric. Desc: time in millisec
     *
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * origin - Type: url. Desc: tab's url
     *
     * referral - Type: string. Desc: referral url. When creating a new site from my account:  {MA_topbar, MA_site_list_top, MA_site_list_bottom,  MA_account_templates}
     *
     * source - Type: string. Desc: vertical selector - reason for appearing
     *
     * total - Type: numeric. Desc: total folds - amount of folds in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {verticalSelectorFinishLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.verticalSelectorFinishLoad = function (params) {
        return this.bi.log(__assign({ evid: 319 }, params));
    };
    /**
    * @typedef {Object} hpUserInFoldParams
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {Url} origin - tab's url
    * @property {number} total - total folds - amount of folds in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP - User in fold. Evid: 317.
     * Event description: user spent over 3 sec in fold.
    
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * origin - Type: url. Desc: tab's url
     *
     * total - Type: numeric. Desc: total folds - amount of folds in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpUserInFoldParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpUserInFold = function (params) {
        return this.bi.log(__assign({ evid: 317 }, params));
    };
    /**
    * @typedef {Object} hpVideosDidNotPlayParams
    * @property {Url} origin - tab's url
    * @property {string} version - Homepage version
    **/
    /**
     * Name: HP - videos did not play. Evid: 323.
     * Event description: HP folds did not display videos.
    
     * origin - Type: url. Desc: tab's url
     *
     * version - Type: string. Desc: Homepage version
     * @param {hpVideosDidNotPlayParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpVideosDidNotPlay = function (params) {
        return this.bi.log(__assign({ evid: 323 }, params));
    };
    /**
    * @typedef {Object} verticalSelectorStartLoadParams
    * @property {number} fold - fold number
    * @property {string} fold_name - fold's name
    * @property {Url} origin - tab's url
    * @property {string} referral - referral url. When creating a new site from my account:  {MA_topbar, MA_site_list_top, MA_site_list_bottom,  MA_account_templates}
    * @property {string} source - vertical selector - reason for appearing
    * @property {number} total - total folds - amount of folds in page
    * @property {string} version - Homepage version
    **/
    /**
     * Name: vertical selector - start load. Evid: 318.
     * Event description: vertical selector load.
    
     * fold - Type: numeric. Desc: fold number
     *
     * fold_name - Type: string. Desc: fold's name
     *
     * origin - Type: url. Desc: tab's url
     *
     * referral - Type: string. Desc: referral url. When creating a new site from my account:  {MA_topbar, MA_site_list_top, MA_site_list_bottom,  MA_account_templates}
     *
     * source - Type: string. Desc: vertical selector - reason for appearing
     *
     * total - Type: numeric. Desc: total folds - amount of folds in page
     *
     * version - Type: string. Desc: Homepage version
     * @param {verticalSelectorStartLoadParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.verticalSelectorStartLoad = function (params) {
        return this.bi.log(__assign({ evid: 318 }, params));
    };
    /**
    * @typedef {Object} clickOnViewTemplateParams
    * @property {number} json_id - 1422, 947
    * @property {number} position - 1,2,3,4,5,6
    **/
    /**
     * Name: click on view template. Evid: 303.
     * Event description: clicks on a specific template.
    
     * json_id - Type: numeric. Desc: 1422, 947
     *
     * position - Type: numeric. Desc: 1,2,3,4,5,6
     * @param {clickOnViewTemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnViewTemplate = function (params) {
        return this.bi.log(__assign({ evid: 303 }, params));
    };
    /**
    * @typedef {Object} clickOnWixOfTheDayImageParams
    * @property {Url} url - http://www.dustinlaurenzi.com/
    **/
    /**
     * Name: Click on 'Wix of the day' image. Evid: 307.
     * Event description: Click on 'Wix of the day' image.
    
     * url - Type: url. Desc: http://www.dustinlaurenzi.com/
     * @param {clickOnWixOfTheDayImageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnWixOfTheDayImage = function (params) {
        return this.bi.log(__assign({ evid: 307 }, params));
    };
    /**
    * @typedef {Object} homepageLoadSuccessErrorParams
    * @property {string} message - error name
    **/
    /**
     * Name: Homepage load success error. Evid: 339.
     * Event description: This event fires when the "homepage loads successfully" event(19/316) fails due to a specific reason.
    
     * message - Type: string. Desc: error name
     * @param {homepageLoadSuccessErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.homepageLoadSuccessError = function (params) {
        return this.bi.log(__assign({ evid: 339 }, params));
    };
    /**
    * @typedef {Object} clickOnLearnMoreParams
    * @property {string} type - read_more, close
    **/
    /**
     * Name: Click on 'learn more'. Evid: 309.
     * Event description: Click on 'learn more'.
    
     * type - Type: string. Desc: read_more, close
     * @param {clickOnLearnMoreParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnLearnMore = function (params) {
        return this.bi.log(__assign({ evid: 309 }, params));
    };
    /**
    * @typedef {Object} searchForATemplateParams
    * @property {string} text - music, facebook, blog
    **/
    /**
     * Name: search for a template. Evid: 305.
     * Event description: search for your perfect template (music, arts...).
    
     * text - Type: string. Desc: music, facebook, blog
     * @param {searchForATemplateParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.searchForATemplate = function (params) {
        return this.bi.log(__assign({ evid: 305 }, params));
    };
    /**
    * @typedef {Object} homepageAbTestLabelParams
    * @property {string} label_name - homepage ab test label
    **/
    /**
     * Name: Homepage AB test label. Evid: 326.
     * Event description: homepage ab test label - temporary to override petri bug.
    
     * label_name - Type: string. Desc: homepage ab test label
     * @param {homepageAbTestLabelParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.homepageAbTestLabel = function (params) {
        return this.bi.log(__assign({ evid: 326 }, params));
    };
    /**
    * @typedef {Object} exploreClickOnStartNowParams
    * @property {string} name - name of site in the explore viewer where the click occurred
    * @property {string} url - url of site in the explore viewer where the click occurred
    **/
    /**
     * Name: Explore - click on "start now". Evid: 343.
     * Event description: Explore viewer - user clicked on "start now".
    
     * name - Type: string. Desc: name of site in the explore viewer where the click occurred
     *
     * url - Type: string. Desc: url of site in the explore viewer where the click occurred
     * @param {exploreClickOnStartNowParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.exploreClickOnStartNow = function (params) {
        return this.bi.log(__assign({ evid: 343 }, params));
    };
    /**
    * @typedef {Object} changeLanguageFromHeaderParams
    * @property {string} destination_lng - es,fr,pt,ru,ja
    * @property {string} origin - tab's url
    * @property {string} origin_lng - original lng es,fr,pt,..
    * @property {string} version - Homepage version
    **/
    /**
     * Name: Change language from header. Evid: 313.
     * Event description: Change language from header.
    
     * destination_lng - Type: string. Desc: es,fr,pt,ru,ja
     *
     * origin - Type: string. Desc: tab's url
     *
     * origin_lng - Type: string. Desc: original lng es,fr,pt,..
     *
     * version - Type: string. Desc: Homepage version
     * @param {changeLanguageFromHeaderParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.changeLanguageFromHeader = function (params) {
        return this.bi.log(__assign({ evid: 313 }, params));
    };
    /**
    * @typedef {Object} clickOnFeaturesBoxParams
    * @property {Url} url - http://www.wix.com/website/templates
    * @property {number} position - 1,2,3,4,5,6,7,8
    **/
    /**
     * Name: click on features box. Evid: 306.
     * Event description: clicks on boxes in the bottom of the HP.
    
     * url - Type: url. Desc: http://www.wix.com/website/templates
     *
     * position - Type: numeric. Desc: 1,2,3,4,5,6,7,8
     * @param {clickOnFeaturesBoxParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnFeaturesBox = function (params) {
        return this.bi.log(__assign({ evid: 306 }, params));
    };
    /**
    * @typedef {Object} hpFullStoryStartSessionParams
    * @property {Url} fullstoryurl - FullStory recording URL
    **/
    /**
     * Name: HP - FullStory start session. Evid: 324.
     * Event description: Home page - FullStory started recording session.
    
     * fullstoryurl - Type: url. Desc: FullStory recording URL
     * @param {hpFullStoryStartSessionParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.hpFullStoryStartSession = function (params) {
        return this.bi.log(__assign({ evid: 324 }, params));
    };
    /**
    * @typedef {Object} clickOnSocialButtonsParams
    * @property {string} type - FB, Twitter, Google+, Pintrest
    **/
    /**
     * Name: Click on social buttons. Evid: 301.
     * Event description: On the left-hand side of the homepage there are social icons: FB, Twitter, Google+ , Pintrest.
    
     * type - Type: string. Desc: FB, Twitter, Google+, Pintrest
     * @param {clickOnSocialButtonsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnSocialButtons = function (params) {
        return this.bi.log(__assign({ evid: 301 }, params));
    };
    /**
    * @typedef {Object} clickOnSortByDateUpdatesAndReleasesPageParams
    
    **/
    /**
     * Name: Click on sort by date - Updates and Releases page. Evid: 335.
     * Event description: Click on the sort by date button.
    
    
     * @param {clickOnSortByDateUpdatesAndReleasesPageParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.clickOnSortByDateUpdatesAndReleasesPage = function (params) {
        return this.bi.log(__assign({ evid: 335 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map